const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  loaderWrap: {
    minHeight: 200,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
}));
